/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useState} from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./RequestAccess.css";
import Argos_Logo from "../../images/ar_white.png";

import {AppBar, Box, Toolbar, Typography} from '@mui/material';

// DEF: Request Access Page 
// Returns: Renders Forms for accepting User Information for Requesting Access
export default function RequestAccess() {
  //const { userHasAuthenticated } = useAppContext();
  const [author, setAuthor] = useState("Enter name");
  const [email, setEmail] = useState("Enter email address");
  const [reason, setReason] = useState("Enter reason");
  const [nav, setNav] = React.useState(0);

  function validateForm() {
    return email.length > 0;
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (

    <div className="RequestAccess">
      <Box>
        <AppBar position="static" color="default">
          <Toolbar variant="dense" style={{display: 'flex', background: '#3481d5', minHeight: 55, gap: 10}}>
            <div>
              <img class="logoImage" src={Argos_Logo}/>
            </div>
            <div>
              <Typography sx={{color: '#ffffff', fontSize: 14, width: 490}}>Request Access to Argos</Typography>
            </div>

          </Toolbar>
        </AppBar>
      </Box>

      <Form onSubmit={handleSubmit}>
        <Form.Group size="lg" controlId="email">

          <Form.Label>
            <div class='authorstyle'>First/Last Name</div>
          </Form.Label>
          <Form.Control
            autoFocus
            type="text"
            style={{fontSize: 12, paddingLeft: '1em', paddingTop: '.5em', color: "grey"}}
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="email">

          <Form.Label>
            <div class='emailstyle'>Email Address</div>
          </Form.Label>
          <Form.Control
            type="email"
            style={{fontSize: 12, paddingLeft: '1em', paddingTop: '1em', color: "grey"}}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <box class='reasonBox' size="lg" controlId="reason">
          <Form.Label>
            <div class='reasonstyle'>Reason for requiring access</div>
          </Form.Label>
          <Form.Control
            type="reason"
            style={{fontSize: 12, padding: '5em', paddingLeft: '1em', paddingTop: '1em', color: "grey"}}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </box>
        <Button block="true" size="lg" type="submit" disabled={!validateForm()}>
          Submit
        </Button>
      </Form>
      <img
        src='https://assets.themuse.com/uploaded/companies/15000069/small_logo.png?v=1643075324'
        className='img-thumbnail'
        alt='GM-Logo'
        style={{maxWidth: '8rem'}}
      />
    </div>
  );

}